var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"mapArtwork",staticClass:"map-location-canvas",attrs:{"center":this.center,"zoom":15,"options":{styles: _vm.styles, gestureHandling: 'cooperative',mapTypeControl:false,streetViewControl:false},"marker":this.center}},[_c('gmap-marker',{attrs:{"position":_vm.center,"clickable":false,"draggable":false,"icon":_vm.icon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0d8d3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapArtwork.vue
// module id = null
// module chunks = 